module.exports = __webpack_public_path__ + "static/Content-f43d54c2a968c71526fa2ab1578c5cc4.svg";